import React, { useState, useEffect } from 'react';
import { BarChart3, Loader2 } from 'lucide-react';
import { Analytics } from '../types';
import revshareService from '../services/revshare.service';

const AnalyticsDashboard: React.FC = () => {
  const [analytics, setAnalytics] = useState<Analytics>({
    totalRevenue: 0,
    tokenLaunches: 0,
    activeReferrers: 0,
    totalDistributed: 0
  });
  const [loading, setLoading] = useState(false);

  const loadAnalytics = async () => {
    setLoading(true);
    try {
      const data = await revshareService.getAnalytics();
      setAnalytics(data);
    } catch (error) {
      console.error('Failed to load analytics:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadAnalytics();
  }, []);

  return (
    <div className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-8 border border-gray-700">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold flex items-center">
          <BarChart3 className="w-6 h-6 mr-2 text-purple-400" />
          Revenue Analytics
        </h2>
        <button
          onClick={loadAnalytics}
          disabled={loading}
          className="px-4 py-2 bg-purple-600 rounded-lg hover:bg-purple-700 transition-colors disabled:opacity-50"
        >
          {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : 'Refresh'}
        </button>
      </div>
      
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className="bg-gray-900/50 rounded-lg p-4">
          <div className="text-3xl font-bold text-purple-400">
            {analytics.totalRevenue.toFixed(0)}
          </div>
          <div className="text-sm text-gray-400">Total Revenue (SOL)</div>
        </div>
        
        <div className="bg-gray-900/50 rounded-lg p-4">
          <div className="text-3xl font-bold text-purple-400">
            {analytics.tokenLaunches}
          </div>
          <div className="text-sm text-gray-400">Token Launches</div>
        </div>
        
        <div className="bg-gray-900/50 rounded-lg p-4">
          <div className="text-3xl font-bold text-purple-400">
            {analytics.activeReferrers}
          </div>
          <div className="text-sm text-gray-400">Active Referrers</div>
        </div>
        
        <div className="bg-gray-900/50 rounded-lg p-4">
          <div className="text-3xl font-bold text-purple-400">
            {analytics.totalDistributed.toFixed(0)}
          </div>
          <div className="text-sm text-gray-400">Total Distributed (SOL)</div>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsDashboard;